import { render, staticRenderFns } from "./formulator-extension.vue?vue&type=template&id=2211e8e7&scoped=true&"
import script from "./formulator-extension.vue?vue&type=script&lang=js&"
export * from "./formulator-extension.vue?vue&type=script&lang=js&"
import style0 from "./formulator-extension.vue?vue&type=style&index=0&id=2211e8e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211e8e7",
  null
  
)

export default component.exports